<template>
    <div class="service-bill-detail">
        <div class="title">
            <h2>增值服务费对账单</h2>
            <div>
                <el-button
                    :loading="exportLoading"
                    @click="exportFile('pdf')"
                    >打印PDF
                </el-button>
                <el-button
                    :loading="exportLoading"
                    @click="exportFile('excel')"
                    >下载Excel
                </el-button>
            </div>
        </div>

        <el-row class="statement-detail">
            <el-col :span="8">客户名称：<span>{{dataForm.settleCustomerIdDesc}}</span></el-col>
            <el-col :span="8">账单周期：<span style="color: #F87243">{{dataForm.dateInterval2}}</span></el-col>
            <el-col :span="8">发票税率： 
                <span>{{dataForm.invoiceTaxPercent}}</span>
            </el-col>
            <div class="imgs" v-if="dataForm.isRead"><img src="../../assets/img/已读.png" alt=""></div>
        </el-row>

        <div class="tabTitle">费用明细</div>

        <ab-table
            stripe
            border
            showOrder
            index-label="序号"
            indexWidth="60"
            maxHeight="394"
            :column-list="columns"
            :table-list="tableData"
            showSummary
            :summaryMethod="(param) => getSummaries(param, ['originalAmount', 'settleAmount'])">
        </ab-table> 

         <div class="refundAccount">
            <div class="accountLeft">
                <div class="accountLeft-title">
                    <h5>回款账号</h5>
                    <div @click="copyData"><ab-svg name="my-fuzhi"></ab-svg>复制</div>
                </div>

                <el-alert title="请将以上应付款项付至我司银行账户，有什么疑问可以咨询客服！" type="warning" />

                <el-row>
                    <el-col :span="6">
                        <span>公司名称</span>
                        <div class="div-fs24" style="font-weight: 700">{{dataForm.settleCompanyIdDesc}}</div>
                    </el-col>
                    <el-col :span="8">
                        <span>开户银行</span>
                        <div class="div-fs24" style="font-weight: 700">{{dataForm.bankName}}</div>
                    </el-col>
                    <el-col :span="6">
                        <span>银行账号</span>
                        <div class="div-fs24">{{dataForm.bankAccount}}</div>
                    </el-col>
                    <el-col :span="4">
                        <span>银行联行号</span>
                        <div class="div-fs24">{{dataForm.bankCode}}</div>
                    </el-col>
                </el-row>
            </div>

            <div class="accountRight">
                <h5>应付余额(CNY)</h5>
                <div class="time"><span>{{ dataForm.expireDateMin }}到期</span></div>
                <div class="other number">{{ dataForm.settleAmount }}</div>
            </div>
        </div>


        <ab-footer>
            <el-button @click="back">返回</el-button>
        </ab-footer>

        <textarea style="width: 0; height: 0" id="inputCopy">复制元素</textarea>
    </div>
</template>

<script>
export default {
    name: 'service-bill-detail',
    data() {
        return {
            dataForm: {},
            exportLoading: false,
            tableData: [],
            id: '',
            columns: [
                {
                    labels: '订单编号',
                    props: 'coreBillNumber',
                    widths: 170
                },
                {
                    labels: '发生日期',
                    props: 'bizDate',
                    widths: 100
                },
                {
                    labels: '计费项目',
                    props: 'expenseItemIdDesc',
                    widths: 200
                },
                {
                    labels: '原币',
                    props: 'originalCurrencyIdDesc',
                    widths: 100
                },
                {
                    labels: '原币金额',
                    props: 'originalAmount',
                    widths: 140,
                    type:'money',
                    align:'right'
                },
                {
                    labels: '折算汇率',
                    props: 'exchangeRate',
                    widths: 120
                },
                {
                    labels: '结算币别',
                    props: 'settleCurrencyIdDesc',
                    widths: 180
                },
                {
                    labels: '结算金额',
                    props: 'settleAmount',
                    widths: 160,
                    type:'money',
                    align:'right'
                },
                {
                    labels: '备注',
                    props: 'remark',
                    widths: 100
                },
            ]
        }
    },
    created() {
        
    },
    activated(){
        this.id = this.$route.query.id || ''
        this.init()
    },
    methods: {
        //表格合计
        getSummaries(param,value) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                let val= value.indexOf(column.property) != -1
                if(val){
                    const values = data.map(item => Number(item[column.property]))
                    sums[index]= values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return this.$calc.add(prev, curr)
                            } else {
                            return prev
                            }
                    }, 0)
                    sums[index] = this.$filters.formatMoney(sums[index])
                }
            })
            return sums
        },
        init () {
            if (this.id) {
                this.$get('/sms/client/arAccounts/get', { id: this.id }).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.dataForm = data.result
                        this.tableData = data.result.logisticsList || []
                    }
                })
            }
        },
        //打印
        exportFile (type) {
            this.exportLoading = true
            this.$get(`/sms/client/arAccounts/${type}ByLogisticsByYxClient`, { id: this.id }).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    this.windowOpenFile(data.result)
                } else {
                    this.$message.error(data.message)
                }
            }).finally(() => {
                this.exportLoading = false
            })
        },
        windowOpenFile (url) {
        // 创建隐藏的可下载链接
            var eleLink = document.createElement('a')
            eleLink.download = ''
            eleLink.target = '_blank'
            eleLink.style.display = 'none'
            // 字符内容转变成blob地址
            eleLink.href = url
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
        },
        //复制
        copyData(){
            var input = document.getElementById("inputCopy");  // 找到虚拟的输入框
            let temp = ''
            temp += '公司名称: ' + this.dataForm.settleCompanyIdDesc + '\n'
            temp += '开户银行: ' + this.dataForm.bankName + '\n'
            temp += '银行账号: ' + this.dataForm.bankAccount + '\n'
            temp += '银行联行号: ' + (this.dataForm.bankCode || '')
            input.value = temp; // 修改文本框的内容
            input.select(); // 选中文本
            document.execCommand("copy"); // 执行浏览器复制命令
            this.$message.success('复制成功!')
        },
        back(){
            this.$router.push({
                path: '/service-bill-list'
            })
        }
    },
}
</script>

<style lang="scss">
    .service-bill-detail{
        padding: 25px 0;
        text-align: left;
        color: #000000;
        .title{
            position: relative;
            
            h2{
                height: 45px;
                line-height: 45px;
                text-align: center;
                font-size: 24px;
                font-weight: bold;
            }
            &>div{
                position: absolute;
                right: 0;
                top: 0;
            }
        }
        .statement-detail{
            position: relative;
            padding: 30px 0 40px;
            margin-bottom: 40PX;
            font-size: 14px;
            border-bottom: 1px solid #F0F2F5;
            .el-col.el-col-8{
                margin-bottom: 30px;
            }
            .orange{
                color:#F87243 ;
            }
            .imgs{
                position: absolute;
                top: 22px;
                right: 0;
            }
        }
        .tabTitle{
            font-size: 18px;
            margin-bottom: 40px;
        }
        .refundAccount{
            display: flex;
            justify-content: space-between;
            margin: 40px 0;
            .accountLeft{
                width: 75%;
                border-right: 1px solid #f0f2f5;
                padding-right: 20px;
                .accountLeft-title{
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 15px;
                    cursor: pointer;
                    .icon-svg{
                        width: 16px;
                        height: 16px;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                .el-alert{
                    margin-bottom: 12px;
                }
                .el-row{
                    .el-col{
                        span{
                            display: inline-block;
                            font-size: 14px;
                            margin-bottom: 2px;
                        }
                        .div-fs24{
                        font-size: 18px;
                            font-weight: 500;
                        }
                        .div-fs18{
                            font-size: 16px;
                            font-weight: bold;
                        }
                    }
                }
            }

            .accountRight{
                text-align: right;
                h5{
                    font-size: 14px;
                    margin-bottom: 25px;
                }
                .time{
                    font-size: 14px;
                }
                .other{
                    font-size: 36px;
                    color: #F87243;
                    font-weight: 500;
                    margin-top: 20px;
                }
            }
        }
    }
</style>